import { IAllUsersActivities } from "../../type";

export const uploadReportData: IAllUsersActivities[] = [
  

]
